// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './RowLayout.scss';

const RowLayout = ({ children, className }) => <div className={classNames('RowLayout', className)}>{children}</div>;

RowLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
};

export default RowLayout;
